import { NormalFormTextArea } from '../molecules';
import { Button, RowSpacer } from '../atoms';
import { advancedNormalizeDate } from '@/helpers/normalizeDate';
import { useCallback, useRef, useState } from 'react';
import {
  useErrorHandlerContext,
  useIncidentDetailContext,
  useOpeningElementsControllerContext,
  useUserLanguage,
} from '@/customHooks';
import { useCreateNoteFromIncidentMutation } from '@/graphql/generated';
import textsData from '@/textData/IncidentDetailTexts.json'

const TEXT_LIMIT = 2000

export const IncidentDetailNotesList = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.notes : textsData.en.notes

  const { incident, setIncident } = useIncidentDetailContext()
  const notes = incident?.notes

  const [availableChars, setAvailableChars] = useState(TEXT_LIMIT)

  const charsHint = userLanguage === 'es'
    ? `${availableChars} disponibles`
    : `${availableChars} characters left`

  const textRef = useRef<string | null>(null)

  const [createNote, { loading }] = useCreateNoteFromIncidentMutation()

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()
  const { open: errorHandle } = useErrorHandlerContext()

  const onChangeHandle = useCallback((text: string | null) => {
    if (!text || text.length >= TEXT_LIMIT) return
    textRef.current = text;

    setAvailableChars(TEXT_LIMIT - (text.length || 0))
  }, [])

  const onSubmitHanddle = () => {
    createNote({
      variables: {
        incidentId: incident?.id || '',
        description: textRef.current || ''
      }
    })
      .then((response) => {
        confirmDialogModalOpen({
          title: texts.confirmDialog.title,
          description: `${texts.confirmDialog.description}. Id: ${response.data?.createNoteFromIncident.id}`
        })
        setIncident(undefined)
      })
      .catch(errorHandle)
  }

  return (
    <>
      <RowSpacer height={3} />
      <div className="mb-6 rounded-xl bg-white p-4 shadow-[0_4px_12px_rgba(0,0,0,0.08)]">
        <NormalFormTextArea
          placeholder={texts.form.placeHolder}
          label={texts.form.label}
          onChange={onChangeHandle}
        />
        <div className="mt-4 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="pl-0 text-sm sm:pl-8">
            {charsHint}
          </p>
          <Button
            isLoading={loading}
            onClick={onSubmitHanddle}
          >
            Submit
          </Button>
        </div>
      </div>
      {
        notes
          ? (
            notes.map((note) => (
              <div
                key={note.id}
                className="mb-4 rounded-xl bg-white p-4 shadow-[0_4px_12px_rgba(0,0,0,0.08)]"
              >
                <div className="mb-1 text-sm font-bold text-[#555]">
                  {(note.ownerFirstName || note.ownerLastName)
                    ? `${note.ownerFirstName ?? ''} ${note.ownerLastName ?? ''}`.trim()
                    : ''}
                </div>
                <p className="mb-3 text-[0.95rem] text-[#333]">{note.text}</p>
                <div className="text-xs text-[#999]">
                  <span title={note.createdAt}>
                    {advancedNormalizeDate(userLanguage, note.createdAt)}
                  </span>
                </div>
              </div>
            ))
          )
          : <p><b>{texts.noData}</b></p>
      }
    </>
  );
};
